export default "__VITE_ASSET__DNNjt6yQ__"